import {
  SET_CASHIER_SHIFT,
  SET_CASHIER_SHIFTS,
  SET_CASHIER_SHIFT_ERROR,
  SET_CASHIER_SHIFT_LOADING,
} from "../../actions/cashierShiftAction";

const initialState = {
  datas: [],
  current: null,
  loading: false,
  error: null,
};

const cashierShiftReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CASHIER_SHIFTS:
      return {
        ...state,
        datas: action.data,
        error: null,
      };
    case SET_CASHIER_SHIFT:
      return {
        ...state,
        current: action.data,
        error: null,
      };
    case SET_CASHIER_SHIFT_LOADING:
      return {
        ...state,
        loading: action.status,
      };
    case SET_CASHIER_SHIFT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default cashierShiftReducer;
